import { useEffect, useState } from "react";
import { useToast } from '@chakra-ui/react';

export const usePixabaySearch = () => {
  const [query, setQuery] = useState({q:"",index:0});
  const [loading, setLoading] = useState(false);
  const [photos, setPhotos] = useState<any>([]);
  const [videos, setVideos] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [loadmore, setLoadMore] = useState(true);

  const toast = useToast();
  
  useEffect(() => {
    setLoading(true);
    setPage(1);

      //photos
      fetch( query.q
             ? `https://pixabay.com/api/?key=23676851-4d8aecdd5d1e84e8c3cd03d20&order=popular&safesearch=true&per_page=20&page=${page+1}&q=${query.q}`
             : `https://pixabay.com/api/?key=23676851-4d8aecdd5d1e84e8c3cd03d20&order=popular&safesearch=true&per_page=20&page=${page+1}` 
           )
      .then((data) => data.json())
      .then((data) => {
           setPhotos(data.hits)
      })
      .catch(() => {
        setPhotos([]);
          toast({
            title: `The Plugin API is not responding`,
            status: 'error',
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false)
        })

      //videos
      fetch( query.q
          ? `https://pixabay.com/api/videos/?q=${query.q}&per_page=20&key=23676851-4d8aecdd5d1e84e8c3cd03d20&page=${page +1}`
          : `https://pixabay.com/api/videos/?per_page=20&key=23676851-4d8aecdd5d1e84e8c3cd03d20&order=popular&page=${page +1}` 
        )
     .then((data) => data.json())
     .then((data) => {
       setVideos(data.hits)
     })
     .catch(() => {
      setVideos([]);
        toast({
          title: `The Plugin API is not responding.`,
          status: 'error',
          isClosable: true,
        });
     })
     .finally(() => {
       setLoading(false)
     })
  }, [query]);

  const search = (query: any) => {
    setQuery({q:query.q, index:query.index});
  };

  const fetchMoreData = () => {

    fetch(`https://pixabay.com/api/?key=23676851-4d8aecdd5d1e84e8c3cd03d20&order=popular&safesearch=true&per_page=20&page=${page}&q=${query.q}`)
    .then((data) => data.json())
       .then((newData) => { 
         setPhotos([...photos, ...newData.hits]);
       })
       .catch(() => {
              setPhotos([]);
              toast({
                title: `The Plugin is not responding.`,
                status: 'error',
                isClosable: true,
              });
            })
            .finally(() => {
              setLoading(false);
            });
      setPage(page + 1);
  };

  const fetchMoreVideoData = () => {

    fetch(`https://pixabay.com/api/videos/?key=23676851-4d8aecdd5d1e84e8c3cd03d20&order=popular&safesearch=true&per_page=20&page=${page}&q=${query.q}`)
    .then((data) => data.json())
       .then((newData) => { 
         setVideos([...videos, ...newData.hits]);
       })
       .catch(() => {
              setVideos([]);
              toast({
                title: `The Plugin is not responding.`,
                status: 'error',
                isClosable: true,
              });
            })
            .finally(() => {
              setLoading(false);
            });
      setPage(page + 1);
  };

  return { search, photos, videos, loading, fetchMoreData,loadmore, setLoadMore,setPage, fetchMoreVideoData };
};